import { render, staticRenderFns } from "./BtnEdit.vue?vue&type=template&id=9837e494&"
import script from "./BtnEdit.vue?vue&type=script&lang=js&"
export * from "./BtnEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports